module.exports = __webpack_public_path__ + "img/family.6b5f0d1.webp";